import { defineStore, acceptHMRUpdate } from 'pinia'

import { apiClient } from '@/helpers/api.js'
import { useUserStore } from '@/stores/UserStore'
import { useStrapiStore } from '@/stores/StrapiStore'

export const useHomeStore = defineStore('HomeStore', {
  state: () => {
    return {
      todosList: {
        batches_with_missing_details: [],
        batches_with_suggested_edits: [],
      },
      skipDownloadAction: !!JSON.parse(localStorage.getItem("skipDownloadAction")),
      loadingTodos: false,
    }
  },

  getters: {
    gettingStartedSteps() {
      const userStore = useUserStore()
      const strapiStore = useStrapiStore()
      const steps = strapiStore.gettingStartedSteps
      let countOfDoneSteps = 1

      if(!steps.length || !userStore.user){
        return []
      }

      if ((!userStore.user?.actions_completed || !userStore.user?.actions_completed.length) && !this.skipDownloadAction) {
        return steps
      }

      let steps_ = steps.reduce((acc, step) => {
        if (userStore?.user.actions_completed?.includes(step.name)) {
          step = { ...step, done: true }
          countOfDoneSteps = countOfDoneSteps + 1
        } else if (step.name === 'downloaded-app' && this.skipDownloadAction) {
          step = { ...step, done: true }
          countOfDoneSteps = countOfDoneSteps + 1
        }

        acc.push(step)

        return acc
      }, [])

      if (steps.length === countOfDoneSteps && this.skipDownloadAction) {
        steps_ = steps_.reduce((acc, step) => {
          if (step.name === 'downloaded-app') {
            step = { ...step, done: false }
            localStorage.removeItem("skipDownloadAction")
            this.skipDownloadAction = false
          }
  
          acc.push(step)
  
          return acc
        }, [])
      }

      return steps_
    }
  },

  actions: {
    async fetchTodos() {
      try {
        this.loadingTodos = true

        const { data } = await apiClient().get('/todos')
        this.todosList = data
      } catch (error) {
        console.error('fetchTodos error', error)
      } finally {
        this.loadingTodos = false
      }
    },

    async updateCaptureAction(actionName) {
      const userStore = useUserStore()
      try {
        const { data } = await apiClient().patch(`/users/${userStore.user.id}/capture-action`, {
          action: actionName
        })

        userStore.updateUserField('actions_completed', data.action)
      } catch (error) {
        console.error('updateCaptureAction error', error)
      }
    }
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useHomeStore, import.meta.hot))
}